import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/DropdownMenu';
import { Button } from '@/components/ui/Button';
import { useUiStore, type Locale } from '@/stores/ui';

const LOCALE_LABELS: Record<Locale, { label: string; native: string }> = {
  en: { label: 'English', native: 'English' },
  ar: { label: 'Arabic', native: 'العربية' },
  'eg-ar': { label: 'Egyptian Arabic', native: 'مصري' },
};

export function LocaleSwitcher() {
  const { t } = useTranslation('common');
  const locale = useUiStore((s) => s.locale);
  const setLocale = useUiStore((s) => s.setLocale);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t('userMenu.language')}>
          <Languages className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('userMenu.language')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup
          value={locale}
          onValueChange={(v) => setLocale(v as Locale)}
        >
          {(Object.keys(LOCALE_LABELS) as Locale[]).map((l) => (
            <DropdownMenuRadioItem key={l} value={l}>
              <span className="flex w-full items-center justify-between gap-3">
                <span>{LOCALE_LABELS[l].native}</span>
                <span className="text-xs text-[color:var(--color-fg-subtle)]">
                  {LOCALE_LABELS[l].label}
                </span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
